export default class User {

    constructor (user, token) {
        this.user = user
        this.token = token
    }
}